import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditProjectExpenseRequestFailure({ uuid }) {
      const state = getState().find(
        ({ projectExpense }) => projectExpense.uuid === uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isEditProjectExpenseRequestPending({ uuid }) {
      const state = getState().find(
        ({ projectExpense }) => projectExpense.uuid === uuid,
      );

      return state ? state.request.isPending : false;
    },
    isEditProjectExpenseRequestSuccess({ uuid }) {
      const state = getState().find(
        ({ projectExpense }) => projectExpense.uuid === uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
